import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { AlertTriangle } from 'lucide-react';
export function DisclaimerPage() {
  return <div className="min-h-screen bg-offwhite font-sans text-navy" data-id="element-571">
      <Navbar data-id="element-572" />
      <main className="pt-28 pb-20" data-id="element-573">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-574">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-575">
            <div className="w-14 h-14 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-576">
              <AlertTriangle className="w-7 h-7 text-navy" data-id="element-577" />
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-2" data-id="element-578">
              Disclaimer
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-579">
              Effective Date: 24 February 2026
            </p>
            <p className="text-gold-dark font-semibold italic mt-1 text-sm" data-id="element-580">
              A Dream Smile is a Reality
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10" data-id="element-581">
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-582">
              The information provided on this website is for general
              informational purposes only. While De Rien Cash Loan (Pty) Ltd
              ("De Rien", "we", "us") makes every effort to ensure accuracy, we
              do not guarantee that all information is complete, current, or
              free from errors. Website content does not constitute financial
              advice.
            </p>

            <Section title="1. General Information" data-id="element-583">
              <p data-id="element-584">
                The information provided on this website is for general
                informational purposes only.
              </p>
              <p className="mt-2" data-id="element-585">
                While De Rien Cash Loan (Pty) Ltd makes every effort to ensure
                accuracy, we do not guarantee that all information is complete,
                current, or free from errors.
              </p>
              <p className="mt-2" data-id="element-586">
                Website content does not constitute financial advice.
              </p>
            </Section>

            <Section title="2. No Financial Advice" data-id="element-587">
              <p data-id="element-588">Nothing on this website should be interpreted as:</p>
              <ul data-id="element-589">
                <li data-id="element-590">Financial advice</li>
                <li data-id="element-591">Investment advice</li>
                <li data-id="element-592">Legal advice</li>
                <li data-id="element-593">A guarantee of loan approval</li>
              </ul>
              <p className="mt-3" data-id="element-594">
                All loan approvals are subject to credit assessment,
                affordability checks, and compliance review.
              </p>
            </Section>

            <Section title="3. Loan Approval Disclaimer" data-id="element-595">
              <p data-id="element-596">Submitting an online or physical application:</p>
              <ul data-id="element-597">
                <li data-id="element-598">Does not guarantee loan approval</li>
                <li data-id="element-599">
                  Does not create a binding agreement until formally approved
                  and signed
                </li>
                <li data-id="element-600">
                  Is subject to documentation verification and internal
                  assessment
                </li>
              </ul>
              <p className="mt-3" data-id="element-601">
                All final loan terms will be provided in a formal written
                agreement.
              </p>
            </Section>

            <Section title="4. Interest Rates & Fees" data-id="element-602">
              <p data-id="element-603">
                Interest rates, fees, and repayment terms displayed on this
                website:
              </p>
              <ul data-id="element-604">
                <li data-id="element-605">Are indicative</li>
                <li data-id="element-606">May change without notice</li>
                <li data-id="element-607">Are subject to individual risk assessment</li>
              </ul>
              <p className="mt-3" data-id="element-608">
                Final rates and charges will be confirmed in your signed loan
                agreement.
              </p>
            </Section>

            <Section title="5. Third-Party Links" data-id="element-609">
              <p data-id="element-610">
                Our website may contain links to third-party websites. We are
                not responsible for:
              </p>
              <ul data-id="element-611">
                <li data-id="element-612">The content of those websites</li>
                <li data-id="element-613">Their privacy practices</li>
                <li data-id="element-614">Their accuracy or security</li>
              </ul>
              <p className="mt-3" data-id="element-615">
                Accessing third-party links is at your own risk.
              </p>
            </Section>

            <Section title="6. Limitation of Liability" data-id="element-616">
              <p data-id="element-617">
                To the fullest extent permitted by law, De Rien Cash Loan shall
                not be liable for:
              </p>
              <ul data-id="element-618">
                <li data-id="element-619">
                  Any direct or indirect loss arising from use of this website
                </li>
                <li data-id="element-620">Loss resulting from reliance on website information</li>
                <li data-id="element-621">Technical errors, interruptions, or downtime</li>
                <li data-id="element-622">Delays caused by third-party service providers</li>
              </ul>
              <p className="mt-3 font-medium text-navy" data-id="element-623">
                Use of this website is at your own risk.
              </p>
            </Section>

            <Section title="7. Website Security" data-id="element-624">
              <p data-id="element-625">While we implement reasonable security measures:</p>
              <ul data-id="element-626">
                <li data-id="element-627">
                  We do not guarantee the website is free from viruses or
                  harmful components
                </li>
                <li data-id="element-628">
                  Users are responsible for ensuring their devices are protected
                </li>
              </ul>
            </Section>

            <Section title="8. Regulatory Compliance" data-id="element-629">
              <p data-id="element-630">
                De Rien Cash Loan operates in accordance with applicable laws
                and financial regulations of the Republic of Botswana.
              </p>
              <p className="mt-2" data-id="element-631">
                Nothing on this website overrides regulatory requirements or
                formal signed agreements.
              </p>
            </Section>

            <Section title="9. Changes to Disclaimer" data-id="element-632">
              <p data-id="element-633">
                We reserve the right to modify this Disclaimer at any time.
                Updates will be reflected with a revised effective date.
              </p>
            </Section>

            <Section title="10. Contact Information" data-id="element-634">
              <p data-id="element-635">If you have any questions regarding this Disclaimer:</p>
              <div className="mt-4 bg-offwhite rounded-xl p-6 text-sm text-gray-700 space-y-1 border border-gray-100" data-id="element-636">
                <p className="font-bold text-navy" data-id="element-637">
                  De Rien Cash Loan (Pty) Ltd
                </p>
                <p data-id="element-638">Plot 20582, Block 3, Unit 9/10</p>
                <p data-id="element-639">P.O Box 3568, Gaborone</p>
                <p data-id="element-640">
                  Email:{' '}
                  <a href="mailto:derien@derien.co.bw" className="text-navy underline" data-id="element-641">
                    derien@derien.co.bw
                  </a>
                </p>
                <p data-id="element-642">
                  Tel:{' '}
                  <a href="tel:+26774833041" className="text-navy underline" data-id="element-643">
                    +267 74 833 041
                  </a>{' '}
                  /{' '}
                  <a href="tel:+26777685555" className="text-navy underline" data-id="element-644">
                    +267 77 685 555
                  </a>
                </p>
              </div>
            </Section>
          </div>

          <div className="text-center mt-8" data-id="element-645">
            <a href="#" className="text-sm text-gray-500 hover:text-navy transition-colors" data-id="element-646">
              ← Back to Home
            </a>
          </div>
        </div>
      </main>
      <Footer data-id="element-647" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-648">
      <h2 className="text-xl font-heading font-bold text-navy mb-4 pb-2 border-b border-gray-100" data-id="element-649">
        {title}
      </h2>
      <div className="text-gray-600 leading-relaxed space-y-3 text-sm [&_ul]:list-disc [&_ul]:list-inside [&_ul]:space-y-1 [&_ul]:ml-2" data-id="element-650">
        {children}
      </div>
    </div>;
}